import React from 'react';
import { FiArrowRight, FiCheck, FiCode, FiServer, FiLayers } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import '../../App.css';

const services = [
  { icon: <FiCode />, title: "Custom Software", description: "Tailored solutions for your unique business needs" },
  { icon: <FiServer />, title: "Cloud Infrastructure", description: "Scalable and secure cloud architecture" },
  { icon: <FiLayers />, title: "SaaS Development", description: "Software-as-a-service platforms" }
];

const features = [
  "Enterprise-grade security",
  "Continuous deployment",
  "Scalable architecture",
  "Compliance ready"
];

function Landing() {
  return (
    <div className="Landing">

      {/* Hero Section */}
      <section id="hero" className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Cloud Solutions <span className="highlight">Engineered</span> for Growth
            </h1>
            <p className="hero-subtitle">
              Aamb delivers enterprise-grade software solutions with startup agility
            </p>
            <div className="hero-cta">
              <Link to="/about" className="primary-button">Get Started <FiArrowRight /></Link>            
            </div>
          </div>
        </div>
      </section>

       {/* Services Section */}
      <section id="services" className="services-section">
      <div className="container">
          <div className="about-content">
            <span className="section-label">Who We Are</span>
            <h2 className="section-title">Technology Partners for the Digital Age</h2>
            <p className="about-description">
              Aamb brings together cloud architects, software engineers, 
              and data specialists to build the next generation of digital infrastructure.
            </p>
          </div>
        </div>
        <div className="container">
          <span className="section-label">What We Offer</span>
          <h2 className="section-title">Core Services</h2>
          <div className="services-container">
            <div className="services-grid">
              {services.map((service, index) => (
                <div key={index} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

    {/* Features Section */}
    <section className="features-section">
      <div className="container">
        <div className="features-header">
          <span className="section-label">Our Methodology</span>
          <h2 className="section-title">Engineered for Excellence</h2>
        </div>
        <ul className="features-list">
          {features.map((feature, index) => (
            <li key={index} className="feature-item">
              <div className="feature-icon">
                <FiCheck />
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.split(' - ')[0]}</h3>
                {feature.includes(' - ') && (
                  <p className="feature-description">{feature.split(' - ')[1]}</p>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
    </div>
  );
}

export default Landing;
